import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal } from 'react-bootstrap'
import CommentForm from '../CommentForm'
import withLocale from '~/hocs/locale'
import { UserPropType } from '~/utils/prop-types'

const CommentModal = ({
  user,
  isOpen,
  onHide,
  title,
  label,
  placeholder,
  onComment,
  icon,
  skipText,
  bodyLabel,
}) => {
  const onSubmit = ({ body, asAnonymous }) => {
    onComment({ body, asAnonymous })
    onHide()
  }
  return (
    <Modal show={isOpen} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {icon && <FontAwesomeIcon icon={icon} color="red" size="2x" className="mr-2 align-middle" />}
        <span>
          {label}
        </span>
        <CommentForm
          onSubmit={onSubmit}
          user={user}
          showSkip
          placeholder={placeholder}
          skipText={skipText}
          bodyLabel={bodyLabel}
        />
      </Modal.Body>
    </Modal>
  )
}

CommentModal.propTypes = {
  user: UserPropType,
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onComment: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  title: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]),
  placeholder: PropTypes.string.isRequired,
  skipText: PropTypes.string.isRequired,
  bodyLabel: PropTypes.string,
}

CommentModal.defaultProps = {
  icon: undefined,
  user: undefined,
  bodyLabel: '',
  label: ''
}

export default withLocale('common', 'commentModal')(CommentModal)
